function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg034Kazakhstan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#338AF3"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M360.727,266.662H151.273c0,14.461,12.594,26.182,27.054,26.182h-0.872  c0,14.461,11.721,26.182,26.182,26.182c0,14.461,11.721,26.182,26.182,26.182h52.363c14.461,0,26.182-11.721,26.182-26.182  c14.461,0,26.182-11.721,26.182-26.182h-0.872C348.132,292.844,360.727,281.122,360.727,266.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#338AF3"
    },
    d: "M328.504,232.423c0,40.042-32.461,72.504-72.504,72.504s-72.504-32.461-72.504-72.504"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "327.871,225.638 298.504,237.528 314.142,262.008 282.253,256.757 278.212,284.484   256,264.092 233.787,284.484 229.747,256.757 197.858,262.007 213.495,237.527 184.129,225.638 213.496,213.749 197.858,189.27   229.747,194.52 233.788,166.793 256,187.185 278.213,166.793 282.253,194.52 314.143,189.27 298.505,213.75 "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg034Kazakhstan);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6IzMzOEFGMzsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIi8+CjxwYXRoIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiBkPSJNMzYwLjcyNywyNjYuNjYySDE1MS4yNzNjMCwxNC40NjEsMTIuNTk0LDI2LjE4MiwyNy4wNTQsMjYuMTgyaC0wLjg3MiAgYzAsMTQuNDYxLDExLjcyMSwyNi4xODIsMjYuMTgyLDI2LjE4MmMwLDE0LjQ2MSwxMS43MjEsMjYuMTgyLDI2LjE4MiwyNi4xODJoNTIuMzYzYzE0LjQ2MSwwLDI2LjE4Mi0xMS43MjEsMjYuMTgyLTI2LjE4MiAgYzE0LjQ2MSwwLDI2LjE4Mi0xMS43MjEsMjYuMTgyLTI2LjE4MmgtMC44NzJDMzQ4LjEzMiwyOTIuODQ0LDM2MC43MjcsMjgxLjEyMiwzNjAuNzI3LDI2Ni42NjJ6Ii8+CjxwYXRoIHN0eWxlPSJmaWxsOiMzMzhBRjM7IiBkPSJNMzI4LjUwNCwyMzIuNDIzYzAsNDAuMDQyLTMyLjQ2MSw3Mi41MDQtNzIuNTA0LDcyLjUwNHMtNzIuNTA0LTMyLjQ2MS03Mi41MDQtNzIuNTA0Ii8+Cjxwb2x5Z29uIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiBwb2ludHM9IjMyNy44NzEsMjI1LjYzOCAyOTguNTA0LDIzNy41MjggMzE0LjE0MiwyNjIuMDA4IDI4Mi4yNTMsMjU2Ljc1NyAyNzguMjEyLDI4NC40ODQgICAyNTYsMjY0LjA5MiAyMzMuNzg3LDI4NC40ODQgMjI5Ljc0NywyNTYuNzU3IDE5Ny44NTgsMjYyLjAwNyAyMTMuNDk1LDIzNy41MjcgMTg0LjEyOSwyMjUuNjM4IDIxMy40OTYsMjEzLjc0OSAxOTcuODU4LDE4OS4yNyAgIDIyOS43NDcsMTk0LjUyIDIzMy43ODgsMTY2Ljc5MyAyNTYsMTg3LjE4NSAyNzguMjEzLDE2Ni43OTMgMjgyLjI1MywxOTQuNTIgMzE0LjE0MywxODkuMjcgMjk4LjUwNSwyMTMuNzUgIi8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };